import { doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Stamp users/{uid}.lastActiveAt so the owner's active-users metric can count real
 * usage (including students, who GA can't see). Throttled to once per calendar day
 * per device via localStorage so it costs at most one tiny write per user per day.
 * Writes only lastActiveAt on the user's own doc — permitted by firestore.rules
 * (isOwner, no immutable field touched). Best-effort: never throws into the caller.
 *
 * Lives in its own module rather than dataService because App.tsx calls it on every
 * load, and App.tsx renders the public landing page — importing it from dataService
 * pulled the entire Firestore CRUD layer into the landing page's chunk.
 */
export const recordUserActivity = async (uid: string): Promise<void> => {
  if (!uid) return;
  try {
    const key = `luc_last_active_${uid}`;
    const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
    if (typeof localStorage !== 'undefined' && localStorage.getItem(key) === today) return;
    await updateDoc(doc(db, 'users', uid), { lastActiveAt: new Date().toISOString() });
    try { localStorage.setItem(key, today); } catch { /* storage blocked — just re-writes next load */ }
  } catch (err) {
    console.warn('[recordUserActivity] failed', err);
  }
};
